import { render, staticRenderFns } from "./visual_2.vue?vue&type=template&id=115b81fa&"
import script from "./visual_2.vue?vue&type=script&lang=js&"
export * from "./visual_2.vue?vue&type=script&lang=js&"
import style0 from "./visual_2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports